import { api } from './instance'
import type { TopologyLayout } from '../types'

export const topologyLayoutsApi = {
  getLayouts: async (): Promise<TopologyLayout[]> => {
    const { data } = await api.get('/topology-layouts')
    return data
  },

  getLayoutById: async (id: string): Promise<TopologyLayout> => {
    const { data } = await api.get(`/topology-layouts/${id}`)
    return data
  },

  createLayout: async (layout: {
    name: string
    description?: string
    nodePositions: string
    timeRange?: string
    isShared: boolean
    isDefault: boolean
  }): Promise<TopologyLayout> => {
    const { data } = await api.post('/topology-layouts', layout)
    return data
  },

  updateLayout: async (id: string, updates: Partial<TopologyLayout>): Promise<TopologyLayout> => {
    const { data } = await api.put(`/topology-layouts/${id}`, updates)
    return data
  },

  deleteLayout: async (id: string): Promise<void> => {
    await api.delete(`/topology-layouts/${id}`)
  },
}
